const translationBreadCrumbs: { [key: string]: string } = {
	home: 'Página Inicial',
	'planejamento-de-escalas-e-ferias': 'Planejamento de Escalas e Férias',
	'visualizar-pendencias': 'Visualizar Pendências',
	'cargos-e-requisitos': 'Cargos',
	'controle-de-requisitos': 'Controle de Requisitos',
	colaboradores: 'Colaboradores',
	'idas-extras': 'Idas Extras ao Polo',
	realocacoes: 'Solicitação de Realocação',
	'matriz-treinamento-regulatorio': 'Matriz de Treinamento Regulatórios',
	'matriz-treinamento-procedimento': 'Matriz de Treinamento de Procedimentos',
	'controle-treinamentos': 'Controle de Treinamentos',
	'planejamento-de-turma': 'Planejamento de Turma',
	ficheiros: 'Ficheiros',
	'visualizar-fornecedores': 'Visualizar Fornecedores',
	detalhamento: 'Detalhamento das Turmas',
	'historico-treinamentos': 'Histórico de Treinamentos',
	'visualizar-estrutura-organograma': 'Estrutura e Organograma',
	'cadastro-alocacoes-fixas': 'Alocações Fixas',
	'cadastro-de-diretoria': 'Cadastro de Diretoria',
	'fluxos-de-aprovacao': 'Fluxos de Aprovação',
	'aprovar-idas-extras': 'Aprovações Idas Extras',
	bloqueios: 'Bloqueios',
	'bloqueios-catraca': 'Bloqueios de Catraca',
	'parametros-da-catraca': 'Parâmetros da Catraca',
	'tipos-de-atividades': 'Tipos de Atividades',
	'treinamentos-suricatta': 'Treinamentos Suricatta',
	'permissao-de-trabalho': 'Permissão de Trabalho',
};

const disabledBreadCrumbs: string[] = ['detalhamento'];

export { disabledBreadCrumbs, translationBreadCrumbs };
